<template>
  <div class="container">
    <div class="invoice-head trans">
      <invoice-header :headerConfig="headerConfig" @handleClickIocn="handleClickIocn" />
      <div class="invoice-content">
        <div class="invoice-info">
          <h2 class="tit">发票信息: 数电发票</h2>
          <div class="form">
            <invoice-form :form="localItem" :loading="loading" :list="list" :btns="btns" :rules="rules" labelWidth="auto"
              labelPosition="top" ref="iForm" />
          </div>
        </div>
      </div>
      <sign-dialog v-model="dialogShow" :dialogConfig="dialogConfig" @closeDialog="closeDialog">
        <component :is="currentView" :dialogConfig="dialogConfig" @handleClickSure="handleClickSure" />
      </sign-dialog>
      <invoice-success-dialog v-model="invoiceSuccessDialog" :dialogConfig="invoiceSuccessDialogConfig"
        @closeDialog="closeInvoiceSuccessDialog">
        <component :is="currentInvoiceSuccessView" :dialogConfig="invoiceSuccessDialogConfig"
          @handleClickSure="handleInvoiceSuccessClickSure" />
      </invoice-success-dialog>
    </div>
  </div>
</template>

<script>
import invoiceHeader from "@/components/header";
import invoiceForm from "@/components/form";
import { Invoice } from "@/store/entity/invoice";
import { InvoicePageInfo } from "@/store/entity/invoicepageinfo";
import signDialog from "@/components/dialog";
import invoiceSuccessDialog from "@/components/dialog";
import CurrentUserMixin from "../../mixin/CurrentUser.vue";
import merge from "lodash/merge";
import radio from "@/components/radio";
export default {
  name: "invoicePage",
  components: {
    invoiceHeader,
    invoiceForm,
    signDialog,
    invoiceSuccessDialog,
    invoiceFail: () => import("./components/invoiceFail.vue"),
    invoiceSuccess: () => import("./components/invoiceSuccess.vue"),
  },
  mixins: [CurrentUserMixin],
  data() {
    return {
      loading: false,
      dialogShow: false,
      invoiceSuccessDialog: false,
      dialogConfig: {
        width: "80%",
      },
      invoiceSuccessDialogConfig: {
        width: "80%",
      },
      currentView: "invoiceFail",
      currentInvoiceSuccessView: "invoiceSuccess",
      headerConfig: {
        headerIcon: "city ct-xiangyou",
        headerTitle: "申请发票",
      },
      reason: "",
      rules: {
        TITLE_TYPE: [
          {
            required: true,
            message: "请选择抬头类型",
          },
        ],
        fplx: [
            {
              required: true,
              message: "请选择发票类型",
            },
        ],
        // GMF_SJH: [
        //   {
        //     required: true,
        //     message: "请输入手机号",
        //     trigger: "blur",
        //   },
        //   {
        //     pattern:
        //       /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/,
        //     message: "请输入正确手机号",
        //   },
        // ],
        GMF_MC: [{ required: true, message: "请输入购买方名称" }],
        GMF_DZYX: [
          {
            required: true, message: "购买方电子邮箱"
          },
          {
            pattern:
              /^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/,
            message: "请输入正确购买方电子邮箱",
          },
        ],
        GMF_NSRSBH: [{ required: true, message: "请输入购买方税号/身份证号" }],
      },
      localItem: new Invoice(),
      invoicepageinfo: null,
      FPMX: {},
    };
  },

  created() {
    if (this.currentSignup.paid_order_id) {

      this.getInvoiceInfomation(this.currentSignup);
    }
    this.getInvoicePageInfo();
  },
  watch: {
    currentSignup: {
      handler(currentSignup) {
        this.getInvoiceInfomation(currentSignup);
      },
      deep: true,
    },
    'localItem.TITLE_TYPE':{
      handler(val){
        if(val=="单位票据"){
          this.rules.GMF_NSRSBH[0].required = true;
        }else{
          this.rules.GMF_NSRSBH[0].required = false;
        }
        //清除表单中所有输入字段的校验状态
        this.$refs.iForm.clearValidate();
      },deep:true
    }
  },
  computed: {
    // currentSignup(){
    //   ret
    // },
    list() {
      return [
        {
          label: "抬头类型",
          prop: "TITLE_TYPE",
          render: radio,
          attrs: {
            options:["单位票据","个人票据"],
          },
          position: {
            span: 12,
          },
          listeners: {
              //typechange: this.typechange
          },
        },
        {
          label: "发票类型",
          prop: "FPLX",
          render: radio,
          attrs: {
            options: ["数电普票","数电专票"],
          },
          position: {
            span: 12,
          },
        },
        {
          label: "购买方名称",
          prop: "GMF_MC",
          render: "ElInput",
          attrs: {
            placeholder: "请输入购买方名称",
          },
          position: {
            span: 24,
          },
        },
        // {
        //   label: "购买方手机号",
        //   prop: "GMF_SJH",
        //   render: "ElInput",
        //   attrs: {
        //     placeholder: "请输入购买方手机号",
        //   },
        //   position: {
        //     span: 24,
        //   },
        // },
        {
          label: "购买方电子邮箱",
          prop: "GMF_DZYX",
          render: "ElInput",
          attrs: {
            placeholder: "用于接收推送的发票",
          },
          position: {
            span: 24,
          },
        },
        {
          label: "税号/身份证号:单位填税号,个人填身份证号",
          prop: "GMF_NSRSBH",
          render: "ElInput",
          attrs: {
            placeholder: "请输入购买方税号/身份证号",
          },
          position: {
            span: 24,
          },
        },
        {
          label: "销售方银行账号是否显示",
          prop: "SFZSXSFYHZH",
          render: radio,
          attrs: {
            options: ["否", "是"],
          },
          position: {
            span: 12,
          },
          listeners: {},
        },
        {
          label: "销售方地址电话是否显示",
          prop: "SFZSXSFDZDH",
          render: radio,
          attrs: {
            options: ["否", "是"],
          },
          position: {
            span: 12,
          },
        },
        {
          label: "购买方银行账号是否显示",
          prop: "SFZSGMFYHZH",
          render: radio,
          attrs: {
            options: ["否", "是"],
          },
          position: {
            span: 12,
          },
          listeners: {},
        },
        {
          label: "购买方地址电话是否显示",
          prop: "SFZSGMFDZDH",
          render: radio,
          attrs: {
            options: ["否", "是"],
          },
          position: {
            span: 12,
          },
        },
        {
          label: "购买方地址",
          prop: "GMF_DZ",
          render: "ElInput",
          attrs: {
            placeholder: "请输入购买方地址",
          },
          position: {
            span: 24,
          },
        },
        {
          label: "购买方电话",
          prop: "GMF_DH",
          render: "ElInput",
          attrs: {
            placeholder: "请输入购买方电话",
          },
          position: {
            span: 24,
          },
        },
        {
          label: "购买方银行名称",
          prop: "GMF_YH",
          render: "ElInput",
          attrs: {
            placeholder: "请输入购买方银行名称",
          },
          position: {
            span: 24,
          },
        },
        {
          label: "购买方银行账号",
          prop: "GMF_ZH",
          render: "ElInput",
          attrs: {
            placeholder: "请输入购买方银行账号",
          },
          position: {
            span: 24,
          },
        },

      ];
    },

    btns() {
      return [
        {
          label: "点击提交",
          attrs: {
            style: `
                          width: 100%; 
                        `,
          },
          listeners: {
            click: this.handleFormSubmit,
          },
        },
      ];
    },
  },

  methods: {
    getInvoiceInfomation(item) {
      Invoice.getInvoiceLoginfo({ paid_order_id: item.paid_order_id }).then((res) => {
        this.localItem.signup_id = item.id;
        if (res) {
          this.localItem.GMF_NSRSBH = res.data.gmfnsrsbh;
          this.localItem.GMF_MC = res.data.gmfmc;
          this.localItem.GMF_DZ = res.data.gmfdz;
          this.localItem.GMF_DH = res.data.gmfdh;
          this.localItem.GMF_YH = res.data.gmfkhh;
          this.localItem.GMF_ZH = res.data.gmfzh;
          this.localItem.GMF_SJH = res.data.sjhm;
          this.localItem.GMF_DZYX = res.data.yxdz;
          this.localItem.TITLE_TYPE = res.title_type;
          if(res.data.sfzsxsfyhzh=="Y"){this.localItem.SFZSXSFYHZH="是"} else if(res.data.sfzsxsfyhzh=="N"){this.localItem.SFZSXSFYHZH="否"}; // 是否展示销售方银行账号
          if(res.data.sfzsxsfdzdh=="Y"){this.localItem.SFZSXSFDZDH="是"} else if(res.data.sfzsxsfdzdh=="N"){this.localItem.SFZSXSFDZDH="否"}; // 是否展示销售方地址电话
          if(res.data.sfzsgmfyhzh=="Y"){this.localItem.SFZSGMFYHZH="是"} else if(res.data.sfzsgmfyhzh=="N"){this.localItem.SFZSGMFYHZH="否"}; // 是否展示购买方银行账号
          if(res.data.sfzsgmfdzdh=="Y"){this.localItem.SFZSGMFDZDH="是"} else if(res.data.sfzsgmfdzdh=="N"){this.localItem.SFZSGMFDZDH="否"}; // 是否展示购买方地址电话
          if(res.data.fppz=="01"){
            this.localItem.FPLX = "数电专票";
          }else if(res.data.fppz=="02"){
            this.localItem.FPLX = "数电普票";
          }
        }else{
          this.localItem.GMF_NSRSBH = item.ghnsrsbh;
          this.localItem.GMF_MC = item.ghdwmc;
          this.localItem.GMF_DZ = item.ghdz;
          this.localItem.GMF_DH = item.ghdh;
          this.localItem.GMF_YH = item.ghyh;
          this.localItem.GMF_ZH = item.ghzh;
          this.localItem.GMF_SJH = item.ghsjh;
          this.localItem.GMF_DZYX = item.ghdzyx;
          this.localItem.TITLE_TYPE = item.title_type;
          this.localItem.SFZSXSFYHZH = item.sfzsxsfyhzh; // 是否展示销售方银行账号
          this.localItem.SFZSXSFDZDH = item.sfzsxsfdzdh; // 是否展示销售方地址电话
          this.localItem.SFZSGMFYHZH = item.sfzsgmfyhzh; // 是否展示购买方银行账号
          this.localItem.SFZSGMFDZDH = item.sfzsgmfdzdh; // 是否展示购买方地址电话
          this.localItem.FPLX = item.fplx;
        }
      });
    },
    handleClickIocn() {
      history.go(-1);
    },
    handleSubmit() {
      console.log(this.reason);
    },
    handleFormSubmit() {
      this.loading = true;
      if (!this.localItem.TITLE_TYPE) {
        this.$message({
          message: "抬头类型为必选项",
          onClose: () => {
            this.loading = false;
          },
        });
      }
      else if (!this.localItem.FPLX) {
        this.$message({
          message: "发票类型为必填项",
          onClose: () => {
            this.loading = false;
          },
        });
      }
      else if (!this.localItem.GMF_MC) {
        this.$message({
          message: "购买方名称为必填项",
          onClose: () => {
            this.loading = false;
          },
        });
      } else if (!this.localItem.GMF_DZYX) {
        this.$message({
          message: "购买方电子邮箱为必填项",
          onClose: () => {
            this.loading = false;
          },
        });
      } else if (
        !/^\w+((.\w+)|(-\w+))@[A-Za-z0-9]+((.|-)[A-Za-z0-9]+).[A-Za-z0-9]+$/.test(
          this.localItem.GMF_DZYX
        )
      ) {
        this.$message({
          message: "请输入正确电子邮箱",
          onClose: () => {
            this.loading = false;
          },
        });
      }else if(this.localItem.TITLE_TYPE=="单位票据" && !this.localItem.GMF_NSRSBH){
        this.$message({
          message: "购买方税号为必填项",
          onClose: () => {
            this.loading = false;
          },
        });
      }
      else if(this.localItem.TITLE_TYPE=="单位票据" &&  !/^[0-9A-HJ-NPQRTUWXY]{18}$/.test(
          this.localItem.GMF_NSRSBH
        ) && this.localItem.ghnsrsbh !== "88888888888888888888" && this.localItem.ghnsrsbh !== "610111768824461"){
        this.$message({
          message: "请输入正确购买方税号",
          onClose: () => {
            this.loading = false;
          },
        });
      }else if (this.localItem.TITLE_TYPE=="个人票据" && this.localItem.GMF_NSRSBH.trim().length>0 && !this.isValidIdCard(this.localItem.GMF_NSRSBH)) {
        this.$message({
          message: "请输入正确购买方身份证号",type: 'warning',onClose: () => {
            this.loading = false;
          },
        });
      }
      else {
        this.localItem.createOrUpdateInvoice().then((res) => {
          if (res.code == "S0000") {
            this.invoiceSuccessDialog = true;
            this.invoiceSuccessDialogConfig.title = "成功开票!";
            //this.$router.push("/info");
          } else {
            this.dialogShow = true;
            this.dialogConfig.title = "未成功开票!" + res.msg;
            this.currentView = "invoiceFail";
            //history.go(-1);
          }
        });
      }
    },
    isValidIdCard(idCard) {  
        // 正则表达式，匹配 18 位身份证号  
        // 15 或 18 位，18位时最后一位可以为 X  
        const idCardReg = /(^\d{15}$)|(^\d{17}([0-9]|X)$)/;  
          
        // 校验身份证长度  
        if (idCard.length === 15 || idCard.length === 18) {  
            // 使用正则表达式校验  
            if (idCardReg.test(idCard)) {  
                // 校验通过，进行进一步校验（可选，如校验生日、地区码等）  
                // 这里只是简单的校验，没有进行复杂的逻辑校验  
                return true;  
            }  
        }  
          
        // 如果不满足以上条件，则返回 false  
        return false;  
    } ,
    getInvoicePageInfo() {
      this.localItem.COMMON_FPKJ_XMXXS.push(this.FPMX);
    },
    closeDialog(done) {
      this.loading = false;
      done();
    },
    closeInvoiceSuccessDialog(done) {
      this.handleInvoiceSuccessClickSure();
      this.loading = false;
      done();
    },

    handleClickSure() {
      this.dialogShow = false;
    },
    handleInvoiceSuccessClickSure() {
      this.invoiceSuccessDialog = false;
      history.go(-1);
    },
  },
};
</script>

<style lang="scss" scoped>
.invoice-content {
  margin: 0 15px;

  .invoice-info {
    margin-top: 30px;

    .tit {
      padding-left: 8px;
      border-left: 4px solid var(--main-color);
      font-size: 16px;
      font-weight: bold;
      color: var(--main-color);
    }

    .form {
      margin-top: 30px;
      width: 100%;
      border-radius: 5px;
      box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
    }
    
    .el-form {
      padding-top: 30px;

      ::v-deep .el-col {
        padding: 0 15px;
      }

      ::v-deep .el-form-item {
        margin-bottom: 30px;
      }

      ::v-deep .el-form-item__label {
        color: var(--main-color);
        line-height: 0;
      }

      ::v-deep .el-input__inner {
        border: none;
        border-bottom: 1px solid #ccc;
        background: transparent;
      }

      ::v-deep .el-button {
        color: var(--main-color);

        &:hover {
          color: var(--main-color);
        }

        &:focus {
          color: var(--main-color);
          border-color: #fff;
        }
      }

      ::v-deep .el-select {
        width: 100%;
      }

      ::v-deep .submits {
        position: absolute;
        padding: 0 0 30px;
        bottom: -100px;

        .el-button {
          width: 90vh;
          border: none;
          background: var(--main-color);
          color: #fff;
        }
      }
    }
  }
}

::v-deep .el-dialog {
  background: var(--main-color);
  border-radius: 5px;

  .el-dialog__title,
  .el-dialog__close {
    color: #fff;
  }
}
</style>
